import { createSlice } from "@reduxjs/toolkit";

export const ticketSettingSlice = createSlice({
  name: "ticketSetting",
  initialState: {
    getTicketSettingResult: false,
    getTicketSettingLoading: false,
    getTicketSettingError: false,
    addTicketSettingResult: false,
    addTicketSettingLoading: false,
  },
  reducers: {
    ticketSettingReducers: (state, action) => {
      const { type, payload } = action.payload;
      switch (type) {
        case "GET_TICKETSETTING":
          return {
            ...state,
            getTicketSettingResult: payload.data,
            getTicketSettingLoading: payload.loading,
            getTicketSettingError: payload.error,
          };
        case "ADD_TICKETSETTING":
          return {
            ...state,
            addTicketSettingResult: payload.data,
            addTicketSettingLoading: payload.loading,
          };
        default:
          return state;
      }
    },
  },
});

export const { ticketSettingReducers } = ticketSettingSlice.actions;

export default ticketSettingSlice.reducer;
